// frontend/src/pages/Download.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { apiClient } from '../api/client';
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002/api/v1';

export const Download = ({ user }) => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    // Si no está logueado, lo mandamos al login
    if (!user) {
      navigate('/login');
      return;
    }

    const fetchDownloadUrl = async () => {
      try {
        // 🟢 AHORA USAMOS TU apiClient PARA QUE INYECTE EL TOKEN AUTOMÁTICAMENTE
        const response = await apiClient.get(`/onboarding/exports/download/${uuid}`);

        // Forzamos al navegador a ir a la URL pre-firmada de S3 (Inicia la descarga)
        window.location.href = response.data.download_url;

        // Opcional: Redirigir al dashboard después de unos segundos
        setTimeout(() => navigate('/dashboard'), 3000);

      } catch (err) {
        setError(err.response?.data?.detail || "Error al descargar el archivo. Es posible que el enlace haya caducado.");
      }
    };

    fetchDownloadUrl();
  }, [uuid, user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="bg-white p-8 rounded-3xl shadow-xl max-w-md w-full text-center">
        {error ? (
          <div className="text-red-500 font-bold">{error}</div>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-blue-600 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-black text-slate-800">Preparando tu descarga segura...</h2>
            <p className="text-slate-500 mt-2 text-sm">Por favor, no cierres esta ventana.</p>
          </>
        )}
      </div>
    </div>
  );
};
